import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=5e7cd440&scoped=true"
import script from "./projectOverview.vue?vue&type=script&lang=js"
export * from "./projectOverview.vue?vue&type=script&lang=js"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=5e7cd440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7cd440",
  null
  
)

export default component.exports